export default __webpack_public_path__ + "static/accents-color-accessibility-2-light-04b83268f40605b24e5b4115dbdb8777.png";